module.exports = __webpack_public_path__ + "static/Hungama-91a742eae7c999777d658eab480c819f.png";